import React from 'react';
import { connect } from 'react-redux';
import { Redirect, Route, withRouter } from 'react-router-dom';

const PrivateRoute = (props) => {
  const {
    component: Component,
    session: {
      isAuthenticated = false,
      role,
    },
    role: routeRole,
    key = 'key',
    ...rest
  } = props;

  let render;
  if (!isAuthenticated || (routeRole !== undefined && role !== routeRole)) {
    render = () => (<Redirect to="/login" />);
  } else {
    render = (props) => (<Component key={key} {...props} />);
  }

  return (
    <Route {...rest} render={render} />
  );
};

const mapStateToProps = (state) => ({
  session: state.session.session || {},
});

export default withRouter(connect(
  mapStateToProps,
  null,
)(PrivateRoute));
